import { render, staticRenderFns } from "./headCard.vue?vue&type=template&id=65912270&scoped=true"
import script from "./headCard.vue?vue&type=script&lang=ts"
export * from "./headCard.vue?vue&type=script&lang=ts"
import style0 from "./headCard.vue?vue&type=style&index=0&id=65912270&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65912270",
  null
  
)

export default component.exports